import { useFormikContext } from 'formik';
import { getLocalTimeZone, parseDate, today } from '@internationalized/date';

import { Switch } from '@src/design-system/switch';
import { FormikDatePicker } from '@src/shared/fields/formik-date-picker-field';

import type { TAnnouncementFormValues } from '../schema';
import { AnnouncementSectionTitle } from './announcement-section-title';

export function AnnouncementScheduleSection() {
  const { values, setFieldValue } = useFormikContext<TAnnouncementFormValues>();

  const handleScheduleChange = (checked: boolean) => {
    setFieldValue('scheduleShare', checked);

    if (!checked) {
      setFieldValue('shared_at', '');
      setFieldValue('expire_at', '');
    }
  };

  return (
    <section className='flex w-full flex-col gap-4 rounded-xl border border-primary-100 bg-white p-6'>
      <AnnouncementSectionTitle title='5. Schedule Share' />

      <div className='flex items-center gap-2'>
        <Switch
          checked={values.scheduleShare}
          onCheckedChange={handleScheduleChange}
          aria-label='Schedule share'
        />
        <span className='text-sm font-medium text-gray-900'>Schedule</span>
      </div>

      {values.scheduleShare ? (
        <div className='flex flex-col gap-4'>
          <FormikDatePicker
            name='shared_at'
            label='Share at'
            minValue={today(getLocalTimeZone())}
          />
          <FormikDatePicker
            name='expire_at'
            label='Expire at'
            minValue={
              values.shared_at
                ? parseDate(values.shared_at.split('T')[0])
                : today(getLocalTimeZone())
            }
          />
        </div>
      ) : null}
    </section>
  );
}
